import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Table, Image, Button, Typography } from 'antd';
import { StepForwardOutlined } from '@ant-design/icons';
import { listHedgeFunds } from '../../../api/tickersApi';
import {stringMixin} from "../../../utils/strings";


const HedgeFunds = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const hedgeFunds = useSelector((state) => state.tickers.hedgeFunds);
  const status = useSelector((state) => state.tickers.status);
  const error = useSelector((state) => state.tickers.error);

  useEffect(() => {
    if (hedgeFunds.length === 0) {
      dispatch(listHedgeFunds());
    }
  }, [dispatch, hedgeFunds]);

  const columns = [
    {
      title: '',
      dataIndex: 'logo',
      key: 'logo',
      width: 48,
      render: (logo) => (
        <Image
          src={logo || 'https://via.placeholder.com/32'}
          height={32}
          width={32}
          style={{ borderRadius: '4px', objectFit: 'contain' }}
          preview={false}
        />
      ),
    },
    {
      title: 'Fund Name',
      dataIndex: 'name',
      key: 'name',
      render: (name, record) => (
        <div>
          <Typography.Text strong>{stringMixin.fmt(name).replace('Llc', 'LLC').replace('Lp', 'LP')}</Typography.Text>
          <br />
          <Typography.Text type="secondary" style={{ fontSize: '0.825em' }}>
            {record.description || 'Hedge Fund'}
          </Typography.Text>
        </div>
      ),
    },
    {
      title: '',
      key: 'action',
      width: 100,
      align: 'right',
      render: (_, record) => (
        <Button
          type="text"
          icon={<StepForwardOutlined />}
          onClick={() => navigate(`/beta/hedgefunds/${record.name}`)}
        >
          View
        </Button>
      ),
    },
  ];

  return (
    <Table
      dataSource={hedgeFunds}
      columns={columns}
      rowKey="id"
      loading={status === 'loading'}
      pagination={false}
      showHeader={false}
      size="middle"
      style={{ background: 'transparent' }}
      onRow={(record) => ({
        className: 'hover-darken backdrop-blur-md'
      })}
    />
  );
};

export default HedgeFunds;